import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Wrapper = styled.div`
  display: ${props => (props.hidden ? 'none' : 'flex')};
  height: 32px;
  background-color: ${ColorSF2.paleBlue};
  color: #fff;
  border-top: 1px solid ${ColorSF2.mediumGray};
  align-items: center;
  @media (max-width: 600px) {
    flex-wrap: wrap;
    height: 64px;
  }
  position: relative;
`;
export const CompanyArea = styled.div`
  padding: 0px 16px;
  display: flex;
  align-items: center;
  cursor: ${props => (props.clickable ? 'pointer' : 'default')};
`;
export const ArrowImage = styled.img`
  height: 24px;
  display: flex;
  justify-content: center;
`;
export const CompanyNameArea = styled.div`
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 600;
  color: black;
`;

export const GroupArea = styled.div`
  padding: 0px 16px;
`;
export const GroupNameWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const GroupTitle = styled.span`
  margin-right: 9px;
  font-size: 12px;
  font-weight: 600;
  color: black;
`;
export const GroupName = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
export const InputTextField = styled.input`
  width: 200px;
  padding-right: 24px;
  cursor: pointer;
`;
export const DropDownImage = styled.img`
  position: absolute;
  left: 175px;
  top: -2px;
  cursor: pointer;
`;
export const GroupDialogWrapper = styled.div`
  position: absolute;
  left: 355px;
  top: 25px;
  z-index: 1000;
  @media (max-width: 920px) {
    left: auto;
    right: 0px;
  }
  @media (max-width: 600px) {
    top: 58px;
  }
`;
export const DialogBackground = styled.div`
  position: absolute;
  left: -379px;
  top: -75px;
  height: 100vh;
  width: 100vw;
  @media (max-width: 920px) {
    left: auto;
    right: 0px;
  }
  @media (max-width: 600px) {
    top: -108px;
  }
  z-index: 1001;
`;
